'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.second;


// WEBPACK FOOTER //
// ./~/sugar-date/number/second.js